import styled from 'styled-components'

export default styled.label`
  display: flex;
  margin-bottom: 0.5rem;
`
